import { useCallback, useContext, useState } from 'react';
import { useEffect } from 'react';
import { createContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiJalles } from '../services/api';
import { HomeContext } from './contexHome';

export const AdminContext = createContext({});

export const AdminProvider = () => {
  const navigate = useNavigate();

  const { user, headerApi } = useContext(HomeContext);

  const [loading, setLoading] = useState(false);
  const [adminPage, setAdminPage] = useState('User');
  const [usersSave, setUsersSave] = useState([]);
  const [modalUserDeletConfirmation, setModalUserDeletConfirmation] = useState(false);
  const [modalEditUser, setModalEditUser] = useState(false);
  const [modalBTGtw, setModalBTGtw] = useState(false);
  const [modaUpdatePassword, setModalUpdatePassword] = useState(false);
  const [modalCreatingUser, setModalCreatingUser] = useState(false);
  const [salveUserId, setSaveUserId] = useState(0);
  const [saveUserGtw, setSaveUserGtw] = useState(0);

  const [modalConfimation, setModalConfimation] = useState(false);
  const [salveTanqueInfo, setSalveTanqueInfo] = useState([]);
  const [modalBombaTanque, setModalBombaTaque] = useState(false);
  const [modalCreatTanque, setModalCreatTanque] = useState(false);

  const uservalidation = useCallback(async () => {
    setLoading(true);
    try {
      const api = await apiJalles.get('/users/LeituraTodos', headerApi);
      setUsersSave(api.data);
      return true;
    } catch (error) {
      toast.warn('😅Algo de Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
      return false;
    } finally {
      setLoading(false);
    }
  }, [headerApi]);

  const deleteUser = async (id) => {
    setLoading(true);
    try {
      await apiJalles.delete(`/users/${id}`, headerApi);
      await uservalidation();
      toast.success('Usuario Deletado com Sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
      setModalUserDeletConfirmation(false);
    } catch (error) {
      console.error(error);
      toast.warn('😅Algo de Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUsertCreation = async (data) => {
    const { confirmPassword, ...formData } = data;
    const payload = { ...formData, email: formData.email || null };
    setLoading(true);
    try {
      await apiJalles.post(`/users`, payload, headerApi);
      await uservalidation();
      toast.success('Novo usuario criado com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
      setModalCreatingUser(false);
      return true;
    } catch (error) {
      console.error(error);
      toast.warn('Falha Provavelmente UserName ou e-mail já Cadastrados.', {
        position: 'top-right',
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleUserUpdate = async (data) => {
    const { confirmPassword, ...payload } = data;
    setLoading(true);
    try {
      await apiJalles.patch(`users/${salveUserId}/`, payload, headerApi);
      const api = await apiJalles.get('users/LeituraTodos', headerApi);
      setUsersSave(api.data);
      toast.success('Alterações Salvas com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
      setModalEditUser(false);
      setModalUpdatePassword(false);
      return true;
    } catch (error) {
      toast.warn('😅Algo de Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.role === undefined || user?.role === null) {
      return;
    }

    if (Number(user.role) < 3) {
      navigate('/');
    } else {
      uservalidation();
    }
  }, [navigate, user?.role, uservalidation]);

  const isAdmin = Number(user?.role) >= 3;

  return (
    <AdminContext.Provider
      value={{
        loading,
        adminPage,
        setAdminPage,
        usersSave,
        headerApi,
        modalCreatingUser,
        setModalCreatingUser,
        handleUsertCreation,
        modalUserDeletConfirmation,
        setModalUserDeletConfirmation,
        salveUserId,
        setSaveUserId,
        deleteUser,
        modaUpdatePassword,
        setModalUpdatePassword,
        handleUserUpdate,
        modalEditUser,
        setModalEditUser,
        modalBTGtw,
        setModalBTGtw,
        modalConfimation,
        setModalConfimation,
        salveTanqueInfo,
        setSalveTanqueInfo,
        modalBombaTanque,
        setModalBombaTaque,
        modalCreatTanque,
        setModalCreatTanque,
        saveUserGtw,
        setSaveUserGtw,
        uservalidation,
      }}
    >
      {isAdmin ? <Outlet /> : null}
    </AdminContext.Provider>
  );
};
